import { TransactionResubmitRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useResubmitTransaction() {
  const [resubmitting, setResubmitting] = useState(false);

  async function resubmitTransaction(params: TransactionResubmitRequest, bearer: string) {
    try {
      setResubmitting(true);
      const res = await api.postTransactionResubmit(params, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setResubmitting(false);
    }
  }

  return { resubmitting, resubmitTransaction };
}
